import React from "react";

import BannerEnergia from "components/Portal/BannerEnergia";
import BannerPromotions from "components/layout/BannerPromotions";
import BannerReclameAqui from "components/Portal/BannerReclameAqui";
import Bills from "components/layout/portal/boletos";
import CTOS from "components/layout/portal/ctos";
import ModalBackToUnit from "components/Portal/ModalBackToUnit";
import ModalValidationContact from "components/Portal/ModalValidationContact";
import Navbar from "components/MI/Navbar";
import TermoAdesao from "components/Portal/TermoAdesao";
import UserMenu from "components/layout/userMenuNew";
import { PesquisaIndecx } from "components/Portal/PesquisaIndecx";
import { usePortal } from "features/portal/hooks/usePortal";

import PortalBillPanel from "./PortalBillPanel";
import PortalPromoPanel from "./PortalPromoPanel";
import PortalSpendPanel from "./PortalSpendPanel";
import { Container, ContentGrid, Title } from "./PortalPage.styles";

declare global {
  interface Window {
    TrackWidget: any;
  }
}

const PortalPage = (): JSX.Element => {
  const {
    bill,
    bills,
    clientUserId,
    isFirstAccess,
    loading,
    selectedUnit,
    showTour,
    spending,
    tourStep,
    tourType,
  } = usePortal();

  return (
    <>
      <Navbar selected="inicio">
        <UserMenu intro />
        <Container>
          <Title>Início</Title>
          {loading ? (
            <span>Carregando ...</span>
          ) : (
            <ContentGrid>
              {selectedUnit?.hasCurrentHouseholder && (
                <>
                  <PortalBillPanel
                    bill={bill}
                    showTour={showTour}
                    tourStep={tourStep}
                    tourType={tourType}
                  />
                  <PortalSpendPanel
                    spending={spending}
                    showTour={showTour}
                    tourStep={tourStep}
                    tourType={tourType}
                  />
                  {selectedUnit?.hasCurrentHouseholder && <CTOS />}
                </>
              )}
              <Bills data={bills} />
              <PortalPromoPanel
                showTour={showTour}
                tourStep={tourStep}
                tourType={tourType}
              />
            </ContentGrid>
          )}
        </Container>
        {isFirstAccess && (
          <TermoAdesao
            clientUserId={
              localStorage.getItem("@UltragazEmpresarial:document")
                ? `${clientUserId}_${localStorage.getItem(
                    "@UltragazEmpresarial:document"
                  )}`
                : `${clientUserId}`
            }
          />
        )}
        <BannerEnergia />
        <ModalBackToUnit />
        <ModalValidationContact />
        <BannerReclameAqui />
        <PesquisaIndecx />
      </Navbar>
      <BannerPromotions />
    </>
  );
};

export default PortalPage;
